// Вкладки карточки заявки, перенесённые из Office во втором круге (credit). Формат — см. request.js.
// «Рассрочки» — credit/credit-list, credit/credit-edit и окно Freedom Finance (dict/freedom-block).
// Права-вкладки: office_api/office_port/areas/requests/ep_credit.py (TAB_GRANTS).
// Кнопки BI / 1С блока «Интеграция с 1С» (crCredit/Bi1cBlock.vue) подключены во вкладке «Реквизиты: правка» (crProps).
import { defineAsyncComponent } from "vue";

export const tabsCodes = {
  OA__RemontFormOfficeCreditTab: "crCredit",
};

export const components = {
  crCredit: defineAsyncComponent(() => import("./crCredit/index.vue")),
};

export const groups = {
  contract: ["crCredit"],
};

export const aliases = {
  crCredit: "рассрочка кредит банк freedom finance фридом скоринг",
};
